var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58522 0C2.65987 0 1.73583 0.360782 1.04122 1.09398C-0.348013 2.56034 -0.346132 4.90246 1.04122 6.36971L6.17453 11.8073C6.23257 11.8682 6.30238 11.9167 6.37971 11.9498C6.45704 11.9829 6.5403 12 6.62442 12C6.70855 12 6.79181 11.9829 6.86914 11.9498C6.94647 11.9167 7.01628 11.8682 7.07432 11.8073C8.78774 9.99866 10.5007 8.18485 12.2141 6.37618C13.6033 4.90983 13.6033 2.56687 12.2141 1.10046C10.8249 -0.365959 8.51533 -0.365988 7.1261 1.10046L6.62766 1.62479L6.12922 1.09398C5.4346 0.360785 4.51057 0 3.58522 0ZM3.58522 1.21698C4.17396 1.21698 4.76386 1.45703 5.22943 1.94846L6.18101 2.95829C6.23905 3.01919 6.30885 3.06768 6.38618 3.1008C6.46352 3.13393 6.54677 3.15101 6.6309 3.15101C6.71503 3.15101 6.79828 3.13393 6.87561 3.1008C6.95295 3.06768 7.02275 3.01919 7.08079 2.95829L8.02589 1.95493C8.95704 0.972032 10.3832 0.972053 11.3143 1.95493C12.2455 2.93781 12.2454 4.53891 11.3143 5.52171C9.752 7.17088 8.18999 8.82465 6.62766 10.4738L1.941 5.51524C1.01025 4.53087 1.00989 2.93774 1.941 1.95493C1.94102 1.95278 1.94102 1.95063 1.941 1.94847C2.40657 1.45704 2.99648 1.21699 3.58522 1.21699V1.21698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f4e1153b6b7d41d08f91df7147c4cf84.svg";
export { ForwardRef as ReactComponent };